module.exports = __webpack_public_path__ + "img/w3_chevron_left_white.3c99ae2f.png";